import { SalePage } from 'components/main-page/sale-page/SalePage'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_SALE_PAGE } from 'services/apiSalePage'
import { constructOptionMultipleSelect, convertErrorMessage, getValueFromArray, uploadFileToS3 } from 'utils/utils'
import { Alert } from 'avo-ui'
import { GET_ITEM_FIELD_NAME, GET_FIELD_NAME, INITIAL_STATE } from 'configs/main-page/configFormSalePage'

export const SalePageContainer = () => {
    const [reload, setReload] = useState(false)
    const [salePageDetail, setSalePageDetail] = useState(INITIAL_STATE)
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getUrlSalePageBanner } = useFetch(API_SALE_PAGE.URL_BANNER)
    const { fetching: getSalePageDetail, isLoading } = useFetch(API_SALE_PAGE.DETAIL)
    const { fetching: updateSalePage, isLoading: isUpdating } = useFetch(API_SALE_PAGE.UPDATE)

    const onChangeForm = (item) => {
        setSalePageDetail({ ...salePageDetail, ...item })
    }

    const setUploadBanners = async (filesName, uploadDetail) => {
        const newBanners = [...salePageDetail?.banners]

        try {
            const s3Urls = await getUrlSalePageBanner({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newBanners[uploadDetail[i]?.index] = {
                    ...newBanners[uploadDetail[i]?.index],
                    [uploadDetail[i]?.key]: `${item?.url}${item?.fields?.key}`,
                }
            })
            await Promise.all(apiS3list)
            onSave({ ...salePageDetail, banners: newBanners })
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const validateForm = () => {
        const validateHeaderBanners = () => {
            const result = []
            salePageDetail?.banners?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(salePageDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && salePageDetail[key]?.length === 0) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (GET_FIELD_NAME[key] && validateHeaderBanners()?.length) {
                    errors['banners_detail'] = validateHeaderBanners()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(async () => {
            const banners = [...salePageDetail?.banners]
            const uploadDetail = []
            const filesName = []

            const mapBannerImages = (name, file, index, key) => {
                filesName.push(name?.replace(/\s/g, ''))
                uploadDetail.push({ file, key, index })
            }

            banners.map((item, index) => {
                if (item?.desktop_image_url?.name) {
                    mapBannerImages(
                        item?.desktop_image_url?.name,
                        item?.desktop_image_url?.file,
                        index,
                        'desktop_image_url',
                    )
                }

                if (item?.mobile_image_url?.name) {
                    mapBannerImages(
                        item?.mobile_image_url?.name,
                        item?.mobile_image_url?.file,
                        index,
                        'mobile_image_url',
                    )
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadBanners(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...salePageDetail }) => {
        const newPayload = {
            banners: payload?.banners?.map((item, index) => {
                return {
                    ...item,
                    sequence: index,
                }
            }),
            products: getValueFromArray(payload?.products, 'value'),
            vouchers: getValueFromArray(payload?.vouchers, 'value'),
        }
        updateSalePage(newPayload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Sale Page Updated !',
                })
            })
            .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, GET_ITEM_FIELD_NAME)))
    }

    useEffect(() => {
        getSalePageDetail().then((response) => {
            const newDetail = {
                ...response?.data,
                products: constructOptionMultipleSelect(response?.data?.products, 'name', 'id'),
                vouchers: constructOptionMultipleSelect(response?.data?.vouchers, 'code', 'id', 'thumbnail'),
            }
            setSalePageDetail(newDetail)
        })
    }, [reload])

    const props = {
        sectionProps: {
            salePageDetail,
            onChangeForm,
            errorForm,
        },
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <SalePage {...props} />
}
